import React from 'react';
import { useNavigate } from 'react-router-dom';

const PHASE_LABELS = {
  setup: 'Setup',
  customization: 'Customization',
  delivery: 'Delivery',
};

// Color based on progress
function progressColor(pct, isActive) {
  if (!isActive) return 'bg-[#F0EFF4]/5';
  if (pct === 100) return 'bg-emerald-500';
  if (pct >= 60) return 'bg-[#7B61FF]';
  if (pct >= 20) return 'bg-yellow-400';
  return 'bg-[#F0EFF4]/20';
}

function textColor(pct, isActive) {
  if (!isActive) return 'text-[#F0EFF4]/20';
  if (pct === 100) return 'text-emerald-400';
  if (pct >= 60) return 'text-[#7B61FF]';
  if (pct >= 20) return 'text-yellow-400';
  return 'text-[#F0EFF4]/50';
}

// Is this phaseRow active/unlocked for the build's current phase?
function isPhaseActive(phaseRow, buildPhase) {
  const phaseOrder = ['queued', 'setup', 'customization', 'awaiting_delivery', 'delivery', 'deployed'];
  const phaseToRow = { setup: 'setup', customization: 'customization', awaiting_delivery: 'customization', delivery: 'delivery', deployed: 'delivery' };
  const rowIdx = ['setup', 'customization', 'delivery'].indexOf(phaseRow);
  const buildIdx = phaseOrder.indexOf(buildPhase);
  // Active if build has reached or passed this phase row's start
  const rowStartPhase = ['setup', 'customization', 'delivery'][rowIdx];
  return buildIdx >= phaseOrder.indexOf(rowStartPhase);
}

const BuildPhaseCell = ({ buildId, phaseRow, progress, buildPhase }) => {
  const navigate = useNavigate();
  const active = isPhaseActive(phaseRow, buildPhase);
  const { done, total, pct } = progress || { done: 0, total: 0, pct: 0 };

  return (
    <div
      onClick={() => navigate(`/admin/build/${buildId}`)}
      className={`px-3 py-2 rounded-lg cursor-pointer transition-all border ${
        active
          ? 'border-[#F0EFF4]/10 hover:border-[#7B61FF]/50 hover:bg-[#7B61FF]/5'
          : 'border-[#F0EFF4]/5 opacity-40 cursor-default'
      }`}
    >
      {active ? (
        <>
          {/* Progress bar */}
          <div className="w-full h-1.5 bg-[#F0EFF4]/10 rounded-full mb-1.5 overflow-hidden">
            <div
              className={`h-full rounded-full transition-all ${progressColor(pct, active)}`}
              style={{ width: `${pct}%` }}
            />
          </div>
          {/* Count */}
          <div className={`text-[11px] font-data font-bold ${textColor(pct, active)}`}>
            {done}/{total}
            {pct === 100 && <span className="ml-1 text-emerald-400">✓</span>}
          </div>
        </>
      ) : (
        <div className="text-[11px] font-data text-[#F0EFF4]/20">—</div>
      )}
    </div>
  );
};

export default BuildPhaseCell;
